import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next"; // I18N
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import BackersModal from "./BackersPopup";
import LocationModal from "./LocationModal";
import ShareModal from "./ShareModal";
import CommunityModal from "./CommunityModal";
import OrganizationModal from "./OrganizationModal";
import ReCAPTCHA from "react-google-recaptcha";
import { Helmet } from "react-helmet-async"; //  Helmet
import Logo from "../../images/logo2.png";
import axios from "axios";
import { useProjects } from "../../api/ProjectsContext";
import {
  MediaThumbnail,
  MediaViewer,
} from "../../components/MediaDisplay/MediaDisplay";
import MatchingFundTracker from "../../components/MatchingFundTracker/MatchingFundTracker"; // MATCHING FUND FEATURE

import { useLocation } from "react-router-dom";

const CauseSinglePage = () => {
  const { t } = useTranslation(); // I18N
  const { projectDetails: causesData, setProjectDetails: setCauses } =
    useProjects();

  const CauseSingle = causesData;

  const [activeTab, setActiveTab] = useState("story");
  const [mainImage, setMainImage] = useState(null);
  console.log(process.env.REACT_APP_RECAPTCHA_SITE_KEY);

  useEffect(() => {
    if (CauseSingle?.images) {
      const imageList = Object.values(CauseSingle.images).filter(Boolean);
      if (imageList.length > 0) {
        setMainImage(imageList[0]);
      }
    }
  }, [CauseSingle]);

  const [showBackersModal, setShowBackersModal] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [communityOpen, setCommunityOpen] = useState(false);
  const [showOrgModal, setShowOrgModal] = useState(false);
  const [settlementModal, setSettlementModal] = useState(null);

  // Contributors inline expansion state
  const [expandedTransactions, setExpandedTransactions] = useState({});
  const [transactionContributors, setTransactionContributors] = useState({});
  const [contributorsLoading, setContributorsLoading] = useState({});

  const handleToggleContributors = (transaction) => {
    const transactionId = transaction.id;
    const isExpanded = expandedTransactions[transactionId];

    if (isExpanded) {
      // Collapse
      setExpandedTransactions((prev) => ({
        ...prev,
        [transactionId]: false,
      }));
    } else {
      // Expand and fetch if not already loaded
      setExpandedTransactions((prev) => ({
        ...prev,
        [transactionId]: true,
      }));

      if (!transactionContributors[transactionId]) {
        setContributorsLoading((prev) => ({
          ...prev,
          [transactionId]: true,
        }));

        axios
          .get(
            `${process.env.REACT_APP_API_BASE_URL || "https://api.caprover.sokaab.com/api"}/public/projects/${CauseSingle.project_id}/transactions/${transactionId}/contributors`,
          )
          .then((response) => {
            setTransactionContributors((prev) => ({
              ...prev,
              [transactionId]: response.data.contributors || [],
            }));
            setContributorsLoading((prev) => ({
              ...prev,
              [transactionId]: false,
            }));
          })
          .catch((error) => {
            console.error("Error fetching contributors:", error);
            setTransactionContributors((prev) => ({
              ...prev,
              [transactionId]: [],
            }));
            setContributorsLoading((prev) => ({
              ...prev,
              [transactionId]: false,
            }));
          });
      }
    }
  };

  // Helper to get avatar color
  const getAvatarColor = (name) => {
    const colors = [
      "#00CC99",
      "#FF6B6B",
      "#4ECDC4",
      "#45B7D1",
      "#96CEB4",
      "#DDA0DD",
      "#98D8C8",
    ];
    if (!name) return colors[0];
    return colors[name.charCodeAt(0) % colors.length];
  };

  const [showAllUpdates, setShowAllUpdates] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [showUpdateForm, setShowUpdateForm] = useState(false);

  // Filter updates to only show approved ones
  const approvedUpdates =
    CauseSingle?.Project_updates?.filter(
      (update) => update.approved === 1 || update.approved === true,
    ) || [];

  useEffect(() => {
    const card = document.getElementById("donation-card");
    const wrapper = document.getElementById("donation-card-wrapper");
    const tabs = document.getElementById("tabs-section");

    const onScroll = () => {
      if (!card || !wrapper || !tabs) return;

      if (window.innerWidth < 992) {
        card.classList.remove("fixed-card", "stop-card");
        card.style.top = "0";
        card.style.width = "100%";
        return;
      }
      //  desired bottom spacing here
      const desiredBottomSpacing = 30;

      const scrollTop = window.scrollY;
      const cardTop = wrapper.offsetTop;
      const cardHeight = card.offsetHeight;
      const tabsBottom = tabs.offsetTop + tabs.offsetHeight;

      // This effectively sets a "bottom" constraint.
      const maxTopBeforeStop = tabsBottom - cardHeight - desiredBottomSpacing;

      if (
        scrollTop + 100 > cardTop &&
        scrollTop + cardHeight + 100 < tabsBottom
      ) {
        card.classList.add("fixed-card");
        card.classList.remove("stop-card");
        card.style.top = "20px";
      } else if (scrollTop + cardHeight + 100 >= tabsBottom) {
        card.classList.remove("fixed-card");
        card.classList.add("stop-card");
        // card.style.top = `${tabsBottom - cardHeight - cardTop}px`;
        card.style.top = `${
          tabsBottom - cardHeight - wrapper.offsetTop - desiredBottomSpacing
        }px`;
      } else {
        card.classList.remove("fixed-card");
        card.classList.remove("stop-card");
        card.style.top = "0";
      }

      card.style.width = `${wrapper.offsetWidth}px`;
    };

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [pictureFile, setPicture] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaRef, setRecaptchaRef] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const location = useLocation();
  const match = location.pathname.match(/^\/projects\/(\d+)/);
  const id = match ? match[1] : null;

  // Handle reCAPTCHA
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleRecaptchaExpired = () => {
    setRecaptchaToken(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if image is attached
    if (!pictureFile) {
      setSubmitError(t("cause.updates.imageRequired"));
      return;
    }

    // Check if reCAPTCHA is verified
    if (!recaptchaToken) {
      alert(
        "Please verify that you are not a robot by completing the reCAPTCHA.",
      );
      return;
    }

    setIsSubmitting(true);
    setSubmitSuccess(false);
    setSubmitError(null);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("picture", pictureFile);
    formData.append("recaptcha", recaptchaToken);

    try {
      const response = await axios.put(
        `${
          process.env.REACT_APP_API_BASE_URL ||
          "https://api.caprover.sokaab.com/api"
        }/public/projects/${id}/update-activity`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      console.log("updated successfully", response.data);

      // Reset form after successful submission
      setTitle("");
      setDescription("");
      setPicture("");
      setRecaptchaToken(null);
      setSubmitSuccess(true);

      // Reset reCAPTCHA
      if (recaptchaRef) {
        recaptchaRef.reset();
      }
    } catch (error) {
      console.log("Failed to update", error);
      const message =
        error.response?.data?.message ||
        error.message ||
        t("cause.updates.errorFallback");
      setSubmitError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // review section code
  const [reviewForm, setReviewForm] = useState({
    name: "",
    message: "",
    reaction: "",
  });

  const [reactionCounts, setReactionCounts] = useState({
    heart: 0,
    clap: 0,
    highfive: 0,
    pray: 0,
    fire: 0,
  });

  const [showReactionPicker, setShowReactionPicker] = useState(false);

  const reactionIconMap = {
    heart: "fa-heart",
    clap: "fa-hands-clapping",
    highfive: "fa-hands",
    pray: "fa-praying-hands",
    fire: "fa-fire",
  };

  const reactionEmojiMap = {
    heart: "❤️",
    clap: "👏",
    highfive: "🖐️",
    pray: "🙏",
    fire: "🔥",
  };

  const handleQuickReaction = (key) => {
    setReactionCounts((prev) => ({
      ...prev,
      [key]: (prev[key] || 0) + 1,
    }));
    setShowReactionPicker(false);
  };

  const handleSubmitReview = (e) => {
    e.preventDefault();
    const newReview = {
      ...reviewForm,
      date: new Date().toISOString(),
    };

    CauseSingle.reviews = [newReview, ...CauseSingle.reviews];
    setReviewForm({ name: "", message: "", reaction: "" });
  };

  const isLargeScreen = window.innerWidth >= 992;
  const fontSize = isLargeScreen ? "55px" : "20px";

  //LOGIC FOR DONATE BUTTON ---

  // Assuming CauseSingle object is available with an end_date property

  // LOGIC FOR DONATE BUTTON (End Date Only)
  const getDonateButtonText = () => {
    const now = new Date();
    const endDate = new Date(CauseSingle.end_date);

    if (endDate < now) {
      return t("cause.campaignEnded"); // I18N
    }
    return t("cause.donateNow"); // I18N
  };

  const isDonateButtonDisabled = () => {
    const now = new Date();
    const endDate = new Date(CauseSingle.end_date);

    // Disable if end date has passed
    return endDate < now;
  };
  // Helper for rendering project story as paragraphs (from previous answer)
  const renderStoryAsParagraphs = (storyText) => {
    if (!storyText) {
      return null;
    }
    const normalizedStory = storyText
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n");
    const paragraphs = normalizedStory.split("\n");
    return paragraphs
      .filter((paragraph) => paragraph.trim() !== "")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>);
  };
  // sharing model variables

  const currentProject = CauseSingle;
  // Construct the share URL
  const projectShareUrl = currentProject
    ? `${window.location.origin}/projects/${currentProject.id}`
    : "";

  // Construct the donate URL
  const projectDonateUrl = currentProject ? `/donate/${currentProject.id}` : "";

  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={"wpo-site-header-s3"} />
      <PageTitle
        pageTitle={CauseSingle.title}
        pagesub={"Projects"}
        style={{ fontSize }}
      />
      <div className="wpo-case-details-area section-padding">
        <div className="container">
          <div className="row">
            <div className=" col-lg-8 col-md-12 col-12 mb-1 ">
              <div className="row">
                <div
                  className="col-2 d-flex flex-column"
                  style={{ gap: "15px" }}
                >
                  {CauseSingle.images &&
                    Object.values(CauseSingle.images)
                      .filter(Boolean)
                      .map((media, idx) => (
                        <MediaThumbnail
                          key={idx}
                          src={media}
                          alt={`thumbnail ${idx}`}
                          onClick={() => {
                            setMainImage(media);
                          }}
                          isSelected={mainImage === media}
                          style={{
                            width: "100%",
                            height: "80px",
                            objectFit: "cover",
                            cursor: "pointer",
                            border:
                              mainImage === media
                                ? "3px solid #00CC99"
                                : "2px solid transparent",
                            borderRadius: "8px",
                            transition: "border 0.3s",
                          }}
                        />
                      ))}
                </div>
                <div className="col-10">
                  <div className="imgRow">
                    <MediaViewer
                      src={mainImage}
                      alt={CauseSingle.title}
                      className="rounded-lg"
                      style={{
                        objectFit: "cover",
                        height: "100%",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* DONATION CARD */}

            <div
              id="donation-card-wrapper"
              className="cardRow col-lg-4 col-12 col-md-12  position-relative"
            >
              <div id="donation-card" className="card shadow-sm border-light">
                <div className="card-body">
                  <h3 className="text-uppercase text-dark font-weight-bold mb-4">
                    {CauseSingle.title}
                  </h3>

                  {/* --- Start of ONLY calculation changes --- */}
                  {(() => {
                    const fundraised = CauseSingle.fundraised || 0;
                    // Use CauseSingle.funding_goal if available, otherwise fall back to CauseSingle.goal
                    const communityGoal =
                      CauseSingle.funding_goal || CauseSingle.goal || 0;
                    const availableMatchingGrant =
                      CauseSingle.available_grant || 0;

                    // Calculate the matching ratio based on community goal
                    const matchingRatio =
                      communityGoal > 0
                        ? availableMatchingGrant / communityGoal
                        : 0;

                    // Calculate the amount of matching fund theoretically activated by community fundraising
                    const theoreticallyActivatedMatching =
                      fundraised * matchingRatio;

                    // The actual matching used is capped at the available grant amount
                    const matchingUsed = Math.min(
                      theoreticallyActivatedMatching,
                      availableMatchingGrant,
                    );

                    // Community progress bar percentage
                    const communityProgressPercentage =
                      communityGoal > 0
                        ? (fundraised / communityGoal) * 100
                        : 0;

                    // Matching grant utilization percentage
                    const matchingGrantUtilizationPercentage =
                      availableMatchingGrant > 0
                        ? (matchingUsed / availableMatchingGrant) * 100
                        : 0;

                    return (
                      <>
                        {/* Project Value */}
                        <p>
                          <strong>{t("causes.card.projectValue")}</strong> $
                          {(
                            communityGoal + availableMatchingGrant
                          ).toLocaleString()}
                        </p>

                        <div style={{ marginBottom: "15px" }}>
                          <p style={{ fontSize: "14px" }}>
                            <strong>
                              {" "}
                              ${Math.round(fundraised).toLocaleString()}
                            </strong>{" "}
                            {t("cause.raisedOf")}
                            <strong>
                              {" "}
                              ${communityGoal.toLocaleString()}
                            </strong>{" "}
                            {t("cause.goal")}
                          </p>

                          {Math.round(fundraised - communityGoal) >= 1 && (
                            <div
                              style={{
                                background:
                                  "linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)",
                                border: "1px solid #90CAF9",
                                borderRadius: "8px",
                                padding: "10px 14px",
                                marginBottom: "10px",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                              }}
                            >
                              {/* <span style={{ fontSize: "20px" }}>🎉</span> */}
                              <span
                                style={{
                                  color: "#1565C0",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                }}
                              >
                                {t("cause.goalExceededBy", {
                                  amount: Math.round(
                                    fundraised - communityGoal,
                                  ).toLocaleString(),
                                })}
                              </span>
                            </div>
                          )}

                          <div className="progress" style={{ height: "4px" }}>
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{
                                width: `${Math.min(
                                  communityProgressPercentage,
                                  100,
                                )}%`,
                                background:
                                  communityProgressPercentage >= 100
                                    ? "#28a745"
                                    : "#2C3E50",
                              }}
                            ></div>
                          </div>
                        </div>

                        <div>
                          {/* MATCHING FUND FEATURE — full tracker on cause detail page (replaces old static "Matching Fund: $X" line) */}
                          <MatchingFundTracker
                            projectId={CauseSingle.project_id}
                          />
                        </div>
                      </>
                    );
                  })()}
                  {/* --- End of ONLY calculation changes --- */}

                  {/* Dynamic Info Block Style */}
                  <div className="mb-3 mt-3">
                    {/* Remaining Days */}
                    <div className="d-flex align-items-center mb-2">
                      <i className="fas fa-hourglass-half mr-2 p-2 font-color"></i>
                      <small style={{ color: "#010038" }}>
                        {Math.max(
                          0,
                          Math.ceil(
                            (new Date(CauseSingle.end_date) - new Date()) /
                              (1000 * 60 * 60 * 24),
                          ),
                        )}{" "}
                        {t("cause.daysLeft")}
                      </small>
                    </div>

                    {/* Backers */}
                    <div className="d-flex align-items-center mb-2">
                      <i className="fas fa-users mr-2 p-2 font-color"></i>
                      <div
                        onClick={() => setShowBackersModal(true)}
                        className="text-decoration-none"
                        style={{ color: "#010038", cursor: "pointer" }}
                      >
                        <small>
                          {CauseSingle.backers}{" "}
                          <span style={{ textDecoration: "underline" }}>
                            {t("cause.supporters")}
                          </span>
                        </small>
                      </div>
                    </div>

                    {/* Location */}
                    <div className="d-flex align-items-center  mb-2">
                      <i className="fas fa-map-marker-alt mr-2 p-2 font-color"></i>
                      <div
                        onClick={() => setShowLocationModal(true)}
                        className="text-decoration-none"
                        style={{ color: "#010038", cursor: "pointer" }}
                      >
                        <small>
                          <span style={{ textDecoration: "underline" }}>
                            {typeof CauseSingle.location_district === "object"
                              ? CauseSingle.location_district
                              : CauseSingle.location_district}
                          </span>
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="d-block justify-content-between align-items-center buttons">
                    <button
                      className="btnActions2 d-block w-100 px-4 py-2 mt-2 mb-3 text-white fw-bold"
                      onClick={() => setShowShareModal(true)}
                    >
                      {t("cause.share")}
                    </button>
                    {/* <Link to={`/donate/${CauseSingle.id}`} className='text-decoration-none'>
          <button className="btnActions d-block w-100 px-4 py-2 mt-2 text-white fw-bold">
            Donate Now
          </button>
        </Link> */}
                    <Link
                      to={
                        isDonateButtonDisabled()
                          ? "#"
                          : `/donate/${CauseSingle.id}`
                      }
                      className={`text-decoration-none ${
                        isDonateButtonDisabled() ? "disabled-link" : ""
                      }`} // Add a class for disabled state if needed for styling
                    >
                      <button
                        className="btnActions d-block w-100 px-4 py-2 mt-2 text-white fw-bold"
                        disabled={isDonateButtonDisabled()}
                        style={{
                          backgroundColor: isDonateButtonDisabled()
                            ? "#cccccc"
                            : "#00CC99", // Gray out when disabled
                          cursor: isDonateButtonDisabled()
                            ? "not-allowed"
                            : "pointer",
                        }}
                      >
                        {getDonateButtonText()}
                      </button>
                    </Link>
                  </div>
                  {/* Community Info */}
                  <div className="mt-2 mb-2">
                    <div
                      onClick={() => setCommunityOpen(true)}
                      className="text-decoration-none d-flex align-items-center mb-2"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-users-cog mr-2 p-2 font-color"></i>
                      <small>
                        {t("cause.community")}{" "}
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#00CC99",
                          }}
                        >
                          {" "}
                          {CauseSingle.community_name}
                        </span>
                      </small>{" "}
                    </div>
                  </div>

                  {/* Organization Info */}
                  <div className="mt-3">
                    <div
                      onClick={() => setShowOrgModal(true)}
                      className="text-decoration-none d-flex align-items-center mb-2"
                    >
                      <i className="fas fa-building mr-2 p-2 font-color"></i>
                      {t("cause.supportedBy")}{" "}
                      <span
                        style={{
                          textDecoration: "underline",
                          color: "#00CC99",
                        }}
                      >
                        {CauseSingle?.org?.organisation_name}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END CARD */}
          </div>

          {/* TABS SECTION */}

          <div
            id="tabs-section"
            className="nabTab mt-1 col-lg-8 col-md-12 col-12"
          >
            {/* Tab Navigation */}
            <ul
              className="nav"
              style={{
                backgroundColor: "#e7e7e7",
                borderRadius: "5px",
                padding: "8px 10px",
              }}
            >
              <li
                className={`nav-item fs-6 fs-lg-3 ${
                  activeTab === "story" ? "item-active" : ""
                }`}
              >
                <button
                  className="nav-link"
                  onClick={() => setActiveTab("story")}
                >
                  {t("cause.tabs.story")}
                </button>
              </li>
              <li
                className={`nav-item ${
                  activeTab === "updates" ? "item-active" : ""
                }`}
              >
                <button
                  className="nav-link"
                  onClick={() => setActiveTab("updates")}
                >
                  {t("cause.tabs.updates")}
                </button>
              </li>
              <li
                className={`nav-item ${
                  activeTab === "list" ? "item-active" : ""
                }`}
              >
                <button
                  className="nav-link"
                  onClick={() => setActiveTab("list")}
                >
                  {t("cause.tabs.backerList")}
                </button>
              </li>
              {/* hidding rn the expenditure tab */}
              {/* <li className={`nav-item fs-6 fs-lg-3 ${activeTab === "expenditureTransactions" ? "item-active" : ""}`}>
          <button className="nav-link" onClick={() => setActiveTab("expenditureTransactions")}>expenditure</button>
        </li> */}
              {CauseSingle.expenditureTransactions &&
                CauseSingle.expenditureTransactions.length > 0 && (
                  <li
                    className={`nav-item fs-6 fs-lg-3 ${
                      activeTab === "expenditureTransactions"
                        ? "item-active"
                        : ""
                    }`}
                  >
                    <button
                      className="nav-link"
                      onClick={() => setActiveTab("expenditureTransactions")}
                    >
                      {t("cause.tabs.expenditure")}
                    </button>
                  </li>
                )}

              {/* <li
                className={`nav-item fs-6 fs-lg-3 ${
                  activeTab === "review" ? "item-active" : ""
                }`}
              >
                <button
                  className="nav-link"
                  onClick={() => setActiveTab("review")}
                >
                  Reviews
                </button>
              </li> */}
            </ul>

            {/* Tab Content */}
            <div className="tab-content mt-3">
              {activeTab === "story" && (
                <div className="tab-pane fade show active">
                  <h4 className="fw-bold">{t("cause.story.title")}</h4>
                  <p> {renderStoryAsParagraphs(CauseSingle.story)}</p>
                </div>
              )}

              {activeTab === "updates" && (
                <div className="tab-pane fade show active">
                  {/* Updates Header */}
                  <div
                    className="d-flex align-items-center justify-content-between mb-4"
                    style={{
                      padding: "16px 20px",
                      background:
                        "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
                      borderRadius: "12px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #00CC99 0%, #00b386 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 12px rgba(0, 204, 153, 0.3)",
                        }}
                      >
                        <i
                          className="fas fa-newspaper"
                          style={{ color: "#fff", fontSize: "18px" }}
                        ></i>
                      </div>
                      <div>
                        <h5
                          className="fw-bold mb-0"
                          style={{ color: "#2C3E50" }}
                        >
                          {t("cause.updates.title")}
                        </h5>
                        <small style={{ color: "#7f8c8d" }}>
                          {t("cause.updates.posted", {
                            count: approvedUpdates.length || 0,
                          })}
                        </small>
                      </div>
                    </div>
                    {approvedUpdates.length > 0 && (
                      <span
                        style={{
                          background:
                            "linear-gradient(135deg, #00CC99 0%, #00b386 100%)",
                          color: "#fff",
                          padding: "6px 14px",
                          borderRadius: "20px",
                          fontSize: "13px",
                          fontWeight: "600",
                          boxShadow: "0 2px 8px rgba(0, 204, 153, 0.25)",
                        }}
                      >
                        {approvedUpdates.length}{" "}
                        {approvedUpdates.length === 1
                          ? t("cause.updates.updateSingular")
                          : t("cause.updates.updatePlural")}
                      </span>
                    )}
                  </div>

                  {/* Post Update Form - Collapsible */}
                  <div
                    className="mb-4"
                    style={{
                      background: "#fff",
                      borderRadius: "16px",
                      border: "1px solid #e9ecef",
                      overflow: "hidden",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => setShowUpdateForm((v) => !v)}
                      style={{
                        width: "100%",
                        padding: "16px 20px",
                        background:
                          "linear-gradient(135deg, #2C3E50 0%, #34495e 100%)",
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        textAlign: "left",
                      }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i
                          className="fas fa-plus-circle"
                          style={{ color: "#00CC99" }}
                        ></i>
                        <h6 className="fw-bold mb-0" style={{ color: "#fff" }}>
                          {t("cause.updates.share")}
                        </h6>
                      </div>
                      <i
                        className={`fas fa-chevron-${showUpdateForm ? "up" : "down"}`}
                        style={{
                          color: "rgba(255,255,255,0.7)",
                          fontSize: "13px",
                        }}
                      ></i>
                    </button>
                    {showUpdateForm && (
                      <form onSubmit={handleSubmit} style={{ padding: "24px" }}>
                        <div className="mb-4">
                          <label
                            className="form-label fw-semibold d-flex align-items-center gap-2"
                            style={{ color: "#2C3E50", marginBottom: "10px" }}
                          >
                            <i
                              className="fas fa-heading"
                              style={{ color: "#00CC99", fontSize: "14px" }}
                            ></i>
                            {t("cause.updates.titleLabel")}
                            <span style={{ color: "#e53e3e" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={t("cause.updates.titlePlaceholder")}
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                            style={{
                              borderRadius: "10px",
                              padding: "14px 16px",
                              border: "2px solid #e9ecef",
                              transition: "all 0.3s ease",
                              fontSize: "15px",
                            }}
                          />
                        </div>

                        <div className="mb-4">
                          <label
                            className="form-label fw-semibold d-flex align-items-center gap-2"
                            style={{ color: "#2C3E50", marginBottom: "10px" }}
                          >
                            <i
                              className="fas fa-align-left"
                              style={{ color: "#00CC99", fontSize: "14px" }}
                            ></i>
                            {t("cause.updates.descriptionLabel")}
                            <span style={{ color: "#e53e3e" }}>*</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows="4"
                            placeholder={t("cause.updates.bodyPlaceholder")}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                            style={{
                              borderRadius: "10px",
                              padding: "14px 16px",
                              border: "2px solid #e9ecef",
                              resize: "vertical",
                              minHeight: "120px",
                              fontSize: "15px",
                            }}
                          />
                        </div>

                        <div className="mb-4">
                          <label
                            className="form-label fw-semibold d-flex align-items-center gap-2"
                            style={{ color: "#2C3E50", marginBottom: "10px" }}
                          >
                            <i
                              className="fas fa-image"
                              style={{ color: "#00CC99", fontSize: "14px" }}
                            ></i>
                            {t("cause.updates.attachImage")}
                            <span style={{ color: "#e53e3e" }}>*</span>
                          </label>
                          <div
                            style={{
                              border: "2px dashed #e9ecef",
                              borderRadius: "10px",
                              padding: "20px",
                              textAlign: "center",
                              background: "#fafbfc",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <input
                              type="file"
                              id="update-image-input"
                              className="form-control"
                              onChange={(e) => setPicture(e.target.files[0])}
                              style={{ display: "none" }}
                              accept="image/*"
                              required
                            />
                            <label
                              htmlFor="update-image-input"
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <i
                                className="fas fa-cloud-upload-alt"
                                style={{ fontSize: "32px", color: "#00CC99" }}
                              ></i>
                              <span
                                style={{ color: "#7f8c8d", fontSize: "14px" }}
                              >
                                {t("cause.updates.clickToUpload")}
                              </span>
                              <span
                                style={{ color: "#bdc3c7", fontSize: "12px" }}
                              >
                                {t("cause.updates.fileTypes")}
                              </span>
                            </label>
                          </div>
                        </div>

                        {pictureFile && (
                          <div
                            className="mb-4"
                            style={{ position: "relative" }}
                          >
                            <img
                              src={URL.createObjectURL(pictureFile)}
                              alt="Preview"
                              style={{
                                width: "100%",
                                maxHeight: "250px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "2px solid #e9ecef",
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => setPicture("")}
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                background: "rgba(0,0,0,0.6)",
                                border: "none",
                                borderRadius: "50%",
                                width: "32px",
                                height: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="fas fa-times"
                                style={{ color: "#fff" }}
                              ></i>
                            </button>
                          </div>
                        )}

                        <div className="mb-4">
                          <ReCAPTCHA
                            ref={setRecaptchaRef}
                            sitekey={
                              process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
                              "YOUR_RECAPTCHA_SITE_KEY"
                            }
                            onChange={handleRecaptchaChange}
                            onExpired={handleRecaptchaExpired}
                          />
                        </div>

                        {submitSuccess && (
                          <div
                            style={{
                              background:
                                "linear-gradient(135deg, #e8f8f3 0%, #d4f5eb 100%)",
                              border: "1px solid #00CC99",
                              borderRadius: "10px",
                              padding: "14px 18px",
                              marginBottom: "16px",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "10px",
                            }}
                          >
                            <i
                              className="fas fa-check-circle"
                              style={{
                                color: "#00CC99",
                                fontSize: "18px",
                                marginTop: "2px",
                                flexShrink: 0,
                              }}
                            ></i>
                            <span
                              style={{
                                color: "#007a5e",
                                fontSize: "14px",
                                fontWeight: "500",
                                lineHeight: "1.5",
                              }}
                            >
                              {t("cause.updates.successMessage")}
                            </span>
                          </div>
                        )}

                        {submitError && (
                          <div
                            style={{
                              background: "#fff5f5",
                              border: "1px solid #fc8181",
                              borderRadius: "10px",
                              padding: "14px 18px",
                              marginBottom: "16px",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "10px",
                            }}
                          >
                            <i
                              className="fas fa-exclamation-circle"
                              style={{
                                color: "#e53e3e",
                                fontSize: "18px",
                                marginTop: "2px",
                                flexShrink: 0,
                              }}
                            ></i>
                            <span
                              style={{
                                color: "#c53030",
                                fontSize: "14px",
                                fontWeight: "500",
                                lineHeight: "1.5",
                              }}
                            >
                              {submitError}
                            </span>
                          </div>
                        )}

                        <div className="text-end">
                          <button
                            type="submit"
                            className="btn"
                            disabled={!recaptchaToken || isSubmitting}
                            style={{
                              background:
                                recaptchaToken && !isSubmitting
                                  ? "linear-gradient(135deg, #00CC99 0%, #00b386 100%)"
                                  : "#e9ecef",
                              color:
                                recaptchaToken && !isSubmitting
                                  ? "#fff"
                                  : "#95a5a6",
                              fontWeight: "600",
                              padding: "12px 28px",
                              borderRadius: "10px",
                              border: "none",
                              cursor:
                                recaptchaToken && !isSubmitting
                                  ? "pointer"
                                  : "not-allowed",
                              boxShadow:
                                recaptchaToken && !isSubmitting
                                  ? "0 4px 15px rgba(0, 204, 153, 0.35)"
                                  : "none",
                              transition: "all 0.3s ease",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {isSubmitting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                {t("cause.updates.posting")}
                              </>
                            ) : (
                              <>
                                <i className="fas fa-paper-plane"></i>
                                {t("cause.updates.post")}
                              </>
                            )}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>

                  {/* Updates Timeline */}
                  {approvedUpdates.length > 0 ? (
                    <div className="updates-timeline">
                      {approvedUpdates
                        .sort(
                          (a, b) =>
                            new Date(b.date_time_added) -
                            new Date(a.date_time_added),
                        )
                        .slice(0, showAllUpdates ? approvedUpdates.length : 3)
                        .map((update, index) => (
                          <div
                            key={index}
                            className="update-card mb-4"
                            style={{
                              background: "#fff",
                              borderRadius: "16px",
                              overflow: "hidden",
                              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                              border: "1px solid #e9ecef",
                              transition: "all 0.3s ease",
                              position: "relative",
                            }}
                          >
                            {/* Timeline indicator for first item */}
                            {index === 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0",
                                  left: "0",
                                  width: "4px",
                                  height: "100%",
                                  background:
                                    "linear-gradient(180deg, #00CC99 0%, #00b386 100%)",
                                }}
                              ></div>
                            )}

                            {/* Update Image */}
                            {update.picture_url && (
                              <div
                                onClick={() =>
                                  setLightboxImage({
                                    src: update.picture_url,
                                    title:
                                      update.update_title ||
                                      `Update ${index + 1}`,
                                  })
                                }
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  height: "200px",
                                  overflow: "hidden",
                                  cursor: "zoom-in",
                                }}
                              >
                                <img
                                  src={update.picture_url}
                                  alt={
                                    update.update_title || `Update ${index + 1}`
                                  }
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transition: "transform 0.3s ease",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                      "scale(1.03)")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.transform =
                                      "scale(1)")
                                  }
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    bottom: "0",
                                    left: "0",
                                    right: "0",
                                    height: "60px",
                                    background:
                                      "linear-gradient(transparent, rgba(0,0,0,0.4))",
                                  }}
                                ></div>
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    background: "rgba(0,0,0,0.45)",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <i
                                    className="fas fa-expand"
                                    style={{ color: "#fff", fontSize: "13px" }}
                                  ></i>
                                </div>
                              </div>
                            )}

                            {/* Update Content */}
                            <div style={{ padding: "20px 24px" }}>
                              {/* Date Badge */}
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <div
                                  className="d-flex align-items-center gap-2"
                                  style={{
                                    background: "#f8f9fa",
                                    padding: "6px 12px",
                                    borderRadius: "20px",
                                  }}
                                >
                                  <i
                                    className="fas fa-calendar-alt"
                                    style={{
                                      color: "#00CC99",
                                      fontSize: "12px",
                                    }}
                                  ></i>
                                  <small
                                    style={{
                                      color: "#7f8c8d",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {new Date(
                                      update.date_time_added,
                                    ).toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    })}
                                  </small>
                                </div>
                                {index === 0 && (
                                  <span
                                    style={{
                                      background:
                                        "linear-gradient(135deg, #00CC99 0%, #00b386 100%)",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "12px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.5px",
                                    }}
                                  >
                                    {t("cause.updates.latest")}
                                  </span>
                                )}
                              </div>

                              {/* Title */}
                              <h5
                                className="fw-bold mb-3"
                                style={{
                                  color: "#2C3E50",
                                  fontSize: "18px",
                                  lineHeight: "1.4",
                                }}
                              >
                                {update.update_title}
                              </h5>

                              {/* Description */}
                              {update.description && (
                                <p
                                  style={{
                                    color: "#5a6c7d",
                                    fontSize: "15px",
                                    lineHeight: "1.7",
                                    marginBottom: "0",
                                  }}
                                >
                                  {update.description}
                                </p>
                              )}
                            </div>
                          </div>
                        ))}

                      {/* Show More Button */}
                      {approvedUpdates.length > 3 && (
                        <div className="text-center mt-4 mb-2">
                          <button
                            className="btn"
                            onClick={() => setShowAllUpdates(!showAllUpdates)}
                            style={{
                              background: showAllUpdates
                                ? "#fff"
                                : "linear-gradient(135deg, #2C3E50 0%, #34495e 100%)",
                              color: showAllUpdates ? "#2C3E50" : "#fff",
                              border: showAllUpdates
                                ? "2px solid #2C3E50"
                                : "none",
                              fontWeight: "600",
                              padding: "12px 32px",
                              borderRadius: "25px",
                              boxShadow: showAllUpdates
                                ? "none"
                                : "0 4px 15px rgba(44, 62, 80, 0.3)",
                              transition: "all 0.3s ease",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {showAllUpdates ? (
                              <>
                                <i className="fas fa-chevron-up"></i>
                                {t("cause.updates.showLess")}
                              </>
                            ) : (
                              <>
                                {t("cause.updates.viewAll", {
                                  count: approvedUpdates.length,
                                })}
                                <i className="fas fa-chevron-down"></i>
                              </>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    /* Empty State */
                    <div
                      className="text-center py-5"
                      style={{
                        background: "#f8f9fa",
                        borderRadius: "16px",
                        border: "2px dashed #e9ecef",
                      }}
                    >
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                          background: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 20px",
                          boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        }}
                      >
                        <i
                          className="fas fa-newspaper"
                          style={{ fontSize: "32px", color: "#bdc3c7" }}
                        ></i>
                      </div>
                      <h5 style={{ color: "#7f8c8d", marginBottom: "8px" }}>
                        {t("cause.updates.emptyTitle")}
                      </h5>
                      <p
                        style={{
                          color: "#95a5a6",
                          fontSize: "14px",
                          maxWidth: "300px",
                          margin: "0 auto",
                        }}
                      >
                        {t("cause.updates.emptyBody")}
                      </p>
                    </div>
                  )}
                </div>
              )}

              {/* {activeTab === "list" && (
  <div className="tab-pane fade show active">
    <h5 className="fw-bold">List Backers</h5>
    <div className="mt-4">
      <div className="table-responsive">
        <table className="table align-middle shadow-sm rounded">
          <thead>
            <tr style={{ backgroundColor: "#2C3E50", color: "white", borderRadius: "8px" }}>
              <th className="text-white">#</th>
              <th className="text-white">Backer</th>
              <th className="text-white">Amount</th>
              <th className="text-white">Source</th>
              <th className="text-white">Date</th>
            </tr>
          </thead>
          <tbody>
            {CauseSingle.transactions.map((transaction, index) => {
              const tranAmt = parseFloat(transaction.TranAmt);
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <strong>
                      {transaction.Category?.toLowerCase() === "card" ||
                      transaction.Category?.toLowerCase() === "dahabshiil bank"
                        ? transaction.CustomerName
                        : transaction.Narration}
                    </strong>
                    {transaction.settlement ? (
                      <button
                        type="button"
                        onClick={() => setSettlementModal(transaction)}
                        title="Funds settled to community account"
                        style={{
                          marginLeft: 8,
                          border: "1px solid #00CC99",
                          background: "rgba(0, 204, 153, 0.08)",
                          color: "#00A37A",
                          borderRadius: 999,
                          padding: "1px 8px",
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                          lineHeight: 1.6,
                        }}
                      >
                        <i className="fas fa-check-circle"></i>
                        Settled
                      </button>
                    ) : null}
                  </td>
                  <td className="text-success fw-bold">${tranAmt.toFixed(2)}</td>
                  <td>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {transaction.Category?.toLowerCase() === "card" ? (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#666"
                          style={{ marginRight: "4px" }}
                        >
                          <rect x="2" y="5" width="20" height="14" rx="2" strokeWidth="2" />
                          <line x1="2" y1="10" x2="22" y2="10" strokeWidth="2" />
                        </svg>
                      ) : (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000"
                          style={{ marginRight: "4px" }}
                        >
                          <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z" strokeWidth="2" />
                          <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4H3V5z" strokeWidth="2" />
                        </svg>
                      )}
                      {transaction.Category || "Salaam Somali Bank"}
                    </span>
                  </td>
                  <td>
                    <i className="far fa-calendar-alt me-1"></i>
                    {new Date(transaction.TranDate).toLocaleDateString()}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
      <div className="mt-2">
        {(() => {
          const totalAmount = CauseSingle.transactions.reduce(
            (acc, transaction) => acc + parseFloat(transaction.TranAmt || 0),
            0
          );
          const formattedTotal = totalAmount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          return (
            <h6 className="fw-bold">
              Total Amount: <span className="text-success">${formattedTotal}</span>
            </h6>
          );
        })()}
      </div>
    </div>
  </div>
)} */}
              {activeTab === "list" && (
                <div style={{ margin: 0, padding: 0 }}>
                  <h5 style={{ marginBottom: "1.5rem", fontWeight: "bold" }}>
                    {t("cause.backerList.title")}
                  </h5>
                  <div
                    className="table-container"
                    style={{ overflowX: "auto" }}
                  >
                    <table
                      className="styled-table"
                      style={{
                        fontSize: "1.1rem",
                        width: "95%",
                        borderCollapse: "collapse",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      <thead>
                        <tr style={{ background: "#2C3E50", color: "white" }}>
                          <th
                            style={{ padding: "0.6rem", textAlign: "center" }}
                          >
                            #
                          </th>
                          <th style={{ padding: "0.6rem" }}>
                            {t("cause.backerList.backer")}
                          </th>
                          <th style={{ padding: "0.6rem", textAlign: "left" }}>
                            {t("cause.backerList.amount")}
                          </th>
                          <th style={{ padding: "0.6rem" }}>
                            {t("cause.backerList.fee")}
                          </th>
                          <th style={{ padding: "0.6rem" }}>
                            {t("cause.backerList.source")}
                          </th>
                          <th style={{ padding: "0.6rem" }}>
                            {t("cause.backerList.date")}
                          </th>
                          <th
                            style={{ padding: "0.6rem", textAlign: "center" }}
                          >
                            {t("cause.backerList.contributors")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {CauseSingle.transactions &&
                          CauseSingle.transactions.map((transaction, index) => {
                            const tranAmt = parseFloat(transaction.TranAmt);
                            const isCard =
                              transaction.Category?.toLowerCase() === "card";
                            const fee = isCard ? tranAmt * 0.038 : 0;
                            const isExpanded =
                              expandedTransactions[transaction.id];
                            const txContributors =
                              transactionContributors[transaction.id] || [];
                            const isLoading =
                              contributorsLoading[transaction.id];

                            const rowStyle =
                              index % 2 === 0
                                ? { background: "white" }
                                : { background: "rgba(240, 247, 255, 0.5)" };

                            return (
                              <React.Fragment key={index}>
                                <tr style={rowStyle}>
                                  <td
                                    style={{
                                      padding: "0.5rem",
                                      textAlign: "center",
                                      borderBottom: isExpanded
                                        ? "none"
                                        : "1px solid #eee",
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    style={{
                                      padding: "0.5rem",
                                      color: "black",
                                      borderBottom: isExpanded
                                        ? "none"
                                        : "1px solid #eee",
                                    }}
                                  >
                                    <strong>
                                      {transaction.Category?.toLowerCase() ===
                                        "card" ||
                                      transaction.Category?.toLowerCase() ===
                                        "dahabshiil bank"
                                        ? transaction.CustomerName
                                        : transaction.Narration}
                                    </strong>
                                    {transaction.settlement ? (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          setSettlementModal(transaction)
                                        }
                                        title={t(
                                          "cause.backerList.settledTooltip",
                                        )}
                                        style={{
                                          marginLeft: 8,
                                          border: "1px solid #00CC99",
                                          background: "rgba(0, 204, 153, 0.08)",
                                          color: "#00A37A",
                                          borderRadius: 999,
                                          padding: "1px 8px",
                                          fontSize: 11,
                                          fontWeight: 600,
                                          cursor: "pointer",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 4,
                                          lineHeight: 1.6,
                                        }}
                                      >
                                        <i className="fas fa-check-circle"></i>
                                        {t("cause.backerList.settled")}
                                      </button>
                                    ) : null}
                                  </td>
                                  <td
                                    style={{
                                      padding: "0.8rem",
                                      textAlign: "left",
                                      color: "#2b9348",
                                      borderBottom: isExpanded
                                        ? "none"
                                        : "1px solid #eee",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        style={{ marginRight: "4px" }}
                                      >
                                        <path
                                          d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      {tranAmt.toFixed(2)}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      padding: "0.5rem",
                                      textAlign: "left",
                                      color: isCard ? "#dc3545" : "#666",
                                      borderBottom: isExpanded
                                        ? "none"
                                        : "1px solid #eee",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        style={{ marginRight: "4px" }}
                                      >
                                        <path
                                          d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      {fee.toFixed(2)}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      padding: "0.5rem",
                                      fontSize: "1rem",
                                      color: "black",
                                      borderBottom: isExpanded
                                        ? "none"
                                        : "1px solid #eee",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {transaction.Category?.toLowerCase() ===
                                      "card" ? (
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#666"
                                          style={{ marginRight: "4px" }}
                                        >
                                          <rect
                                            x="2"
                                            y="5"
                                            width="20"
                                            height="14"
                                            rx="2"
                                            strokeWidth="2"
                                          />
                                          <line
                                            x1="2"
                                            y1="10"
                                            x2="22"
                                            y2="10"
                                            strokeWidth="2"
                                          />
                                        </svg>
                                      ) : (
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#666"
                                          style={{ marginRight: "4px" }}
                                        >
                                          <path
                                            d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"
                                            strokeWidth="2"
                                          />
                                          <path
                                            d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4H3V5z"
                                            strokeWidth="2"
                                          />
                                        </svg>
                                      )}
                                      {transaction.bankId ||
                                        "Salaam Somali Bank"}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      padding: "0.5rem",
                                      fontSize: "1rem",
                                      color: "#000",
                                      borderBottom: isExpanded
                                        ? "none"
                                        : "1px solid #eee",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#666"
                                        style={{ marginRight: "4px" }}
                                      >
                                        <rect
                                          x="3"
                                          y="4"
                                          width="18"
                                          height="18"
                                          rx="2"
                                          strokeWidth="2"
                                        />
                                        <line
                                          x1="16"
                                          y1="2"
                                          x2="16"
                                          y2="6"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                        />
                                        <line
                                          x1="8"
                                          y1="2"
                                          x2="8"
                                          y2="6"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                        />
                                        <line
                                          x1="3"
                                          y1="10"
                                          x2="21"
                                          y2="10"
                                          strokeWidth="2"
                                        />
                                      </svg>
                                      {new Date(
                                        transaction.TranDate,
                                      ).toLocaleDateString()}
                                    </span>
                                  </td>
                                  {/* Contributors column - expand/collapse toggle */}
                                  <td
                                    style={{
                                      padding: "0.5rem",
                                      textAlign: "center",
                                      borderBottom: isExpanded
                                        ? "none"
                                        : "1px solid #eee",
                                    }}
                                  >
                                    <button
                                      onClick={() =>
                                        handleToggleContributors(transaction)
                                      }
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        padding: "6px 12px",
                                        backgroundColor: isExpanded
                                          ? "#00CC99"
                                          : transaction.contributorCount > 0
                                            ? "#e8f5e9"
                                            : "#f8f9fa",
                                        border: isExpanded
                                          ? "1px solid #00CC99"
                                          : "1px solid #ddd",
                                        borderRadius: "20px",
                                        cursor: "pointer",
                                        fontSize: "0.8rem",
                                        color: isExpanded
                                          ? "#fff"
                                          : transaction.contributorCount > 0
                                            ? "#2e7d32"
                                            : "#555",
                                        fontWeight: 500,
                                        transition: "all 0.2s ease",
                                        boxShadow: isExpanded
                                          ? "0 2px 4px rgba(0,204,153,0.3)"
                                          : "0 1px 2px rgba(0,0,0,0.05)",
                                      }}
                                      onMouseEnter={(e) => {
                                        if (!isExpanded) {
                                          e.currentTarget.style.backgroundColor =
                                            transaction.contributorCount > 0
                                              ? "#c8e6c9"
                                              : "#e9ecef";
                                          e.currentTarget.style.borderColor =
                                            transaction.contributorCount > 0
                                              ? "#66bb6a"
                                              : "#adb5bd";
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (!isExpanded) {
                                          e.currentTarget.style.backgroundColor =
                                            transaction.contributorCount > 0
                                              ? "#e8f5e9"
                                              : "#f8f9fa";
                                          e.currentTarget.style.borderColor =
                                            "#ddd";
                                        }
                                      }}
                                      title={
                                        isExpanded
                                          ? "Click to collapse"
                                          : transaction.contributorCount > 0
                                            ? `Click to view ${transaction.contributorCount} contributors`
                                            : "Click to view contributors"
                                      }
                                    >
                                      <i
                                        className="fas fa-users"
                                        style={{ fontSize: "0.75rem" }}
                                      ></i>
                                      {transaction.contributorCount > 0 ? (
                                        <span style={{ fontWeight: 600 }}>
                                          {transaction.contributorCount}
                                        </span>
                                      ) : (
                                        <span style={{ fontSize: "0.75rem" }}>
                                          View
                                        </span>
                                      )}
                                      <i
                                        className={`fas fa-chevron-${isExpanded ? "up" : "down"}`}
                                        style={{
                                          fontSize: "0.65rem",
                                          transition: "transform 0.2s ease",
                                        }}
                                      ></i>
                                    </button>
                                  </td>
                                </tr>
                                {/* Inline Contributors Row */}
                                {isExpanded && (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        padding: "0",
                                        borderBottom: "2px solid #e0e0e0",
                                        background:
                                          "linear-gradient(to right, #f8f9fa, #ffffff)",
                                      }}
                                    >
                                      <div
                                        style={{
                                          margin: "0 1rem 1rem 3rem",
                                          padding: "0",
                                        }}
                                      >
                                        {/* Loading state */}
                                        {isLoading && (
                                          <div
                                            style={{
                                              textAlign: "center",
                                              padding: "1.5rem",
                                              color: "#666",
                                            }}
                                          >
                                            <div
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              style={{ marginRight: "8px" }}
                                            ></div>
                                            Loading...
                                          </div>
                                        )}

                                        {/* Contributors list */}
                                        {!isLoading &&
                                          txContributors.length > 0 && (
                                            <table
                                              style={{
                                                width: "100%",
                                                borderCollapse: "collapse",
                                                fontSize: "0.9rem",
                                                background: "#fff",
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                boxShadow:
                                                  "0 1px 4px rgba(0,0,0,0.08)",
                                              }}
                                            >
                                              <thead>
                                                <tr
                                                  style={{
                                                    background: "#f0f7f5",
                                                  }}
                                                >
                                                  <th
                                                    style={{
                                                      padding: "10px 12px",
                                                      textAlign: "left",
                                                      fontWeight: 600,
                                                      color: "#2C3E50",
                                                      borderBottom:
                                                        "1px solid #e0e0e0",
                                                    }}
                                                  >
                                                    Contributor
                                                  </th>
                                                  <th
                                                    style={{
                                                      padding: "10px 12px",
                                                      textAlign: "left",
                                                      fontWeight: 600,
                                                      color: "#2C3E50",
                                                      borderBottom:
                                                        "1px solid #e0e0e0",
                                                    }}
                                                  >
                                                    Phone
                                                  </th>
                                                  <th
                                                    style={{
                                                      padding: "10px 12px",
                                                      textAlign: "left",
                                                      fontWeight: 600,
                                                      color: "#2C3E50",
                                                      borderBottom:
                                                        "1px solid #e0e0e0",
                                                    }}
                                                  >
                                                    Payment Method
                                                  </th>
                                                  <th
                                                    style={{
                                                      padding: "10px 12px",
                                                      textAlign: "left",
                                                      fontWeight: 600,
                                                      color: "#2C3E50",
                                                      borderBottom:
                                                        "1px solid #e0e0e0",
                                                    }}
                                                  >
                                                    Date
                                                  </th>
                                                  <th
                                                    style={{
                                                      padding: "10px 12px",
                                                      textAlign: "right",
                                                      fontWeight: 600,
                                                      color: "#2C3E50",
                                                      borderBottom:
                                                        "1px solid #e0e0e0",
                                                    }}
                                                  >
                                                    Amount
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {txContributors.map(
                                                  (contributor, i) => {
                                                    // Mask phone number: show country code + last 2 digits
                                                    const maskPhone = (
                                                      phone,
                                                    ) => {
                                                      if (!phone) return "—";
                                                      const cleaned =
                                                        phone.replace(
                                                          /\s/g,
                                                          "",
                                                        );
                                                      if (cleaned.length < 4)
                                                        return "•••••";
                                                      // Keep first 4 chars (country code) and last 2
                                                      const start =
                                                        cleaned.slice(0, 4);
                                                      const end =
                                                        cleaned.slice(-2);
                                                      const middleLength =
                                                        Math.max(
                                                          0,
                                                          cleaned.length - 6,
                                                        );
                                                      const middle = "•".repeat(
                                                        middleLength,
                                                      );
                                                      return `${start}${middle}${end}`;
                                                    };
                                                    const maskedPhone =
                                                      maskPhone(
                                                        contributor.mobileNumber,
                                                      );

                                                    return (
                                                      <tr
                                                        key={
                                                          contributor.id || i
                                                        }
                                                        style={{
                                                          background:
                                                            i % 2 === 0
                                                              ? "#fff"
                                                              : "#fafafa",
                                                        }}
                                                      >
                                                        <td
                                                          style={{
                                                            padding:
                                                              "10px 12px",
                                                            borderBottom:
                                                              "1px solid #f0f0f0",
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: 500,
                                                              color: "#333",
                                                            }}
                                                          >
                                                            {contributor.fullName ||
                                                              "Anonymous"}
                                                          </span>
                                                        </td>
                                                        <td
                                                          style={{
                                                            padding:
                                                              "10px 12px",
                                                            color: "#888",
                                                            fontFamily:
                                                              "monospace",
                                                            fontSize: "0.85rem",
                                                            borderBottom:
                                                              "1px solid #f0f0f0",
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <i
                                                              className="fas fa-phone"
                                                              style={{
                                                                fontSize:
                                                                  "0.7rem",
                                                                color: "#aaa",
                                                              }}
                                                            ></i>
                                                            {maskedPhone}
                                                          </span>
                                                        </td>
                                                        <td
                                                          style={{
                                                            padding:
                                                              "10px 12px",
                                                            color: "#666",
                                                            borderBottom:
                                                              "1px solid #f0f0f0",
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              display:
                                                                "inline-flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "4px",
                                                              padding:
                                                                "2px 8px",
                                                              background:
                                                                contributor.paymentMethod ===
                                                                "Cash"
                                                                  ? "#e3f2fd"
                                                                  : contributor.paymentMethod ===
                                                                      "Mobile Money"
                                                                    ? "#fff3e0"
                                                                    : "#e8f5e9",
                                                              borderRadius:
                                                                "12px",
                                                              fontSize:
                                                                "0.8rem",
                                                              fontWeight: 500,
                                                              color:
                                                                contributor.paymentMethod ===
                                                                "Cash"
                                                                  ? "#1565c0"
                                                                  : contributor.paymentMethod ===
                                                                      "Mobile Money"
                                                                    ? "#ef6c00"
                                                                    : "#2e7d32",
                                                            }}
                                                          >
                                                            <i
                                                              className={
                                                                contributor.paymentMethod ===
                                                                "Cash"
                                                                  ? "fas fa-money-bill-wave"
                                                                  : contributor.paymentMethod ===
                                                                      "Mobile Money"
                                                                    ? "fas fa-mobile-alt"
                                                                    : "fas fa-university"
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.7rem",
                                                              }}
                                                            ></i>
                                                            {contributor.paymentMethod ||
                                                              "—"}
                                                          </span>
                                                        </td>
                                                        <td
                                                          style={{
                                                            padding:
                                                              "10px 12px",
                                                            color: "#888",
                                                            fontSize: "0.85rem",
                                                            borderBottom:
                                                              "1px solid #f0f0f0",
                                                          }}
                                                        >
                                                          {contributor.addedOn
                                                            ? new Date(
                                                                contributor.addedOn,
                                                              ).toLocaleDateString()
                                                            : "—"}
                                                        </td>
                                                        <td
                                                          style={{
                                                            padding:
                                                              "10px 12px",
                                                            textAlign: "right",
                                                            fontWeight: 600,
                                                            color: "#00CC99",
                                                            borderBottom:
                                                              "1px solid #f0f0f0",
                                                          }}
                                                        >
                                                          $
                                                          {Number(
                                                            contributor.contributionAmount,
                                                          ).toFixed(2)}
                                                        </td>
                                                      </tr>
                                                    );
                                                  },
                                                )}
                                                {/* Transaction Owner Row - for remaining amount */}
                                                {(() => {
                                                  const totalContributions =
                                                    txContributors.reduce(
                                                      (sum, c) =>
                                                        sum +
                                                        Number(
                                                          c.contributionAmount ||
                                                            0,
                                                        ),
                                                      0,
                                                    );
                                                  const remaining =
                                                    tranAmt -
                                                    totalContributions;

                                                  // Only show if there's remaining amount > 0.01
                                                  if (remaining > 0.01) {
                                                    return (
                                                      <tr
                                                        style={{
                                                          background: "#fff8e1",
                                                        }}
                                                      >
                                                        <td
                                                          colSpan={4}
                                                          style={{
                                                            padding:
                                                              "10px 12px",
                                                            borderBottom:
                                                              "1px solid #f0f0f0",
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              fontWeight: 500,
                                                              color: "#333",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "6px",
                                                            }}
                                                          >
                                                            <i
                                                              className="fas fa-user-tie"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                color:
                                                                  "#ff9800",
                                                              }}
                                                            ></i>
                                                            {transaction.CustomerName ||
                                                              "Depositor"}
                                                            <span
                                                              style={{
                                                                fontSize:
                                                                  "0.7rem",
                                                                color:
                                                                  "#ff9800",
                                                                fontWeight: 600,
                                                                background:
                                                                  "#fff3e0",
                                                                padding:
                                                                  "2px 6px",
                                                                borderRadius:
                                                                  "4px",
                                                              }}
                                                            >
                                                              Depositor
                                                            </span>
                                                          </span>
                                                        </td>
                                                        <td
                                                          style={{
                                                            padding:
                                                              "10px 12px",
                                                            textAlign: "right",
                                                            fontWeight: 600,
                                                            color: "#ff9800",
                                                            borderBottom:
                                                              "1px solid #f0f0f0",
                                                          }}
                                                        >
                                                          $
                                                          {remaining.toFixed(2)}
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                  return null;
                                                })()}
                                                {/* Total Row */}
                                                <tr
                                                  style={{
                                                    background: "#f0f7f5",
                                                    borderTop:
                                                      "2px solid #00CC99",
                                                  }}
                                                >
                                                  <td
                                                    colSpan={4}
                                                    style={{
                                                      padding: "12px",
                                                      fontWeight: 700,
                                                      color: "#2C3E50",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    Total
                                                  </td>
                                                  <td
                                                    style={{
                                                      padding: "12px",
                                                      textAlign: "right",
                                                      fontWeight: 700,
                                                      color: "#00CC99",
                                                      fontSize: "1.1rem",
                                                    }}
                                                  >
                                                    ${tranAmt.toFixed(2)}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          )}

                                        {/* Empty state */}
                                        {!isLoading &&
                                          txContributors.length === 0 && (
                                            <div
                                              style={{
                                                textAlign: "center",
                                                padding: "1.5rem",
                                                marginTop: "12px",
                                                color: "#999",
                                                background: "#fafafa",
                                                borderRadius: "8px",
                                                border: "1px dashed #ddd",
                                              }}
                                            >
                                              <i
                                                className="fas fa-users"
                                                style={{
                                                  fontSize: "1.2rem",
                                                  marginBottom: "6px",
                                                  display: "block",
                                                }}
                                              ></i>
                                              No contributors declared
                                            </div>
                                          )}
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  {CauseSingle.transactions.length > 0 && (
                    <div
                      style={{
                        marginTop: "1.5rem",
                        textAlign: "left",
                        paddingRight: "2.5%",
                      }}
                    >
                      {(() => {
                        const totalAmount = CauseSingle.transactions.reduce(
                          (acc, transaction) =>
                            acc + parseFloat(transaction.TranAmt || 0),
                          0,
                        );
                        const formattedTotal = totalAmount.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        );
                        return (
                          <h5 style={{ fontWeight: "bold" }}>
                            Total Amount:{" "}
                            <span
                              style={{ color: "#2b9348", marginLeft: "30px" }}
                            >
                              ${formattedTotal}
                            </span>{" "}
                          </h5>
                        );
                      })()}
                    </div>
                  )}

                  {CauseSingle.transactions.length <= 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        color: "#666",
                        marginTop: "1.5rem",
                      }}
                    >
                      No data found
                    </p>
                  )}
                </div>
              )}

              {/*    
   {activeTab === "expenditureTransactions" && (
  <div className="tab-pane fade show active">
    <div className="container mt-4">

     
      {(() => {
       
     
const goal = CauseSingle.goal; 
const spent = CauseSingle.expenditureTransactions.reduce((sum, item) => sum + parseFloat(item.TranAmt), 0);
const remaining = goal - spent;

const spentPercent = (spent / goal) * 100;
const remainingPercent = (remaining / goal) * 100;


        return (
          <>
           
            <div className="row mb-4 g-4 justify-content-center">
              
              <div className="col-md-4 d-flex justify-content-center">
    <div
      className="position-relative shadow rounded-circle"
      style={{
        width: "180px",
        height: "180px",
        background: `conic-gradient(
          #4F5D73 0% ${spentPercent}%,
          #66D1B2 ${spentPercent}% 100%
        )`,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "14px",
          background: "#fff",
          borderRadius: "50%",
          width: "100px",
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)",
        }}
      >
        <div>Goal</div>
        ${goal.toFixed(2)}
      </div>
    </div>
  </div>

  <div className="col-md-4 d-flex justify-content-center align-items-center">
  <table
    className="table table-sm mb-0"
    style={{ width: "auto", fontSize: "14px", border: "1px solid #ddd", borderRadius: "5px" }}
  >
    <tbody>
      <tr>
        <td style={{ color: "#28a745", fontWeight: "bold", border: "1px solid #ddd" }}>●</td>
        <td style={{ border: "1px solid #ddd" }}>Goal</td>
        <td className="text-end" style={{ border: "1px solid #ddd" }}>${goal.toFixed(2)}</td>
      </tr>
      <tr>
        <td style={{ color: "#4F5D73", fontWeight: "bold", border: "1px solid #ddd" }}>●</td>
        <td style={{ border: "1px solid #ddd" }}>Total Expenditure</td>
        <td className="text-end" style={{ border: "1px solid #ddd" }}>${spent.toFixed(2)}</td>
      </tr>
      <tr>
        <td style={{ color: "#66D1B2", fontWeight: "bold", border: "1px solid #ddd" }}>●</td>
        <td style={{ border: "1px solid #ddd" }}>Remaining</td>
        <td className="text-end" style={{ border: "1px solid #ddd" }}>${remaining.toFixed(2)}</td>
      </tr>
    </tbody>
  </table>
</div>

            </div>

         
            <div className="mt-4">
              <div className="table-responsive">
                <table className="table align-middle shadow-sm rounded">
                  <thead>
                    <tr style={{ backgroundColor: "#2C3E50", color: "white", borderRadius: "8px" }}>
                      
                      <th className="text-white">Date</th>
                      <th className="text-white">Narration</th>
                      <th className="text-white">Category</th>
                      <th className="text-white">Customer</th>
                     
                      <th className="text-white">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {CauseSingle.expenditureTransactions.map((item, index) => (
                      <tr key={index}>
                       
                        <td><i className="far fa-calendar-alt me-1 text-muted"></i>{item.TranDate}</td>
                        <td>{item.Narration}</td>
                        <td>{item.Category}</td>
                        <td>{item.CustomerName}</td>
                        <td className="text-danger fw-semibold">${parseFloat(item.TranAmt).toFixed(2)}</td>
                      </tr>
                    ))}
                    <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
  <td colSpan="5" className="text-end">Total:</td>
  <td className="text-danger fw-semibold">
    ${CauseSingle.expenditureTransactions
      .reduce((sum, item) => sum + parseFloat(item.TranAmt), 0)
      .toFixed(2)}
  </td>
</tr>

                  </tbody>
                </table>
              </div>
            </div>
          </>
        );
      })()}
    </div>
  </div>





)} */}

              {/* this is the expenditure transaction i hidde it can be come back when we done working on it I'm gonna commit this rn */}

              {CauseSingle.expenditureTransactions &&
                CauseSingle.expenditureTransactions.length > 0 &&
                activeTab === "expenditureTransactions" && (
                  <div style={{ margin: 0, padding: 0 }}>
                    <div style={{ margin: 0, padding: 0 }}>
                      {(() => {
                        const goal = CauseSingle.goal;
                        const spent =
                          CauseSingle.expenditureTransactions.reduce(
                            (sum, item) => sum + parseFloat(item.TranAmt || 0),
                            0,
                          );
                        const remaining = goal - spent;

                        const spentPercent = (spent / goal) * 100;
                        const remainingPercent = (remaining / goal) * 100;

                        return (
                          <>
                            {/* <div
              style={{
                display: "flex", 
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "2rem",
                marginBottom: "2rem", 
              }}
            >
              
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "180px",
                    height: "180px",
                    background: `conic-gradient(
                      #4F5D73 0% ${spentPercent}%,
                      #66D1B2 ${spentPercent}% 100%
                    )`,
                    borderRadius: "50%", 
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)", 
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                      background: "#fff",
                      borderRadius: "50%",
                      width: "100px",
                      height: "100px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "inset 0 0 8px rgba(0,0,0,0.1)", 
                    }}
                  >
                    <div style={{ color: "#4F5D73" }}>Goal</div>{" "}
                    <span style={{ color: "#2b9348", fontSize: "16px" }}>
                      ${goal.toFixed(2)}
                    </span>{" "}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <table
                  style={{
                    width: "auto",
                    fontSize: "14px",
                    borderCollapse: "separate", 
                    borderSpacing: "0 8px",
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)", 
                  }}
                >
                  <tbody>
                    <tr style={{ background: "white" }}>
                      <td
                        style={{
                          color: "#66D1B2", 
                          fontWeight: "bold",
                          padding: "8px 12px",
                          borderBottom: "none", 
                        }}
                      >
                        ●
                      </td>
                      <td
                        style={{
                          padding: "8px 12px",
                          borderBottom: "none",
                          color: "#333",
                        }}
                      >
                        Goal
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          padding: "8px 12px",
                          borderBottom: "none",
                          fontWeight: "bold",
                          color: "#2b9348", 
                        }}
                      >
                        ${goal.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td
                        style={{
                          color: "#4F5D73",
                          fontWeight: "bold",
                          padding: "8px 12px",
                          borderBottom: "none",
                        }}
                      >
                        ●
                      </td>
                      <td
                        style={{
                          padding: "8px 12px",
                          borderBottom: "none",
                          color: "#333",
                        }}
                      >
                        Total Expenditure
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          padding: "8px 12px",
                          borderBottom: "none",
                          fontWeight: "bold",
                          color: "#d62828", 
                        }}
                      >
                        ${spent.toFixed(2)}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td
                        style={{
                          color: "#66D1B2", 
                          fontWeight: "bold",
                          padding: "8px 12px",
                          borderBottom: "none",
                        }}
                      >
                        ●
                      </td>
                      <td
                        style={{
                          padding: "8px 12px",
                          borderBottom: "none",
                          color: "#333",
                        }}
                      >
                        Remaining
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          padding: "8px 12px",
                          borderBottom: "none",
                          fontWeight: "bold",
                          color: remaining >= 0 ? "#2b9348" : "#d62828", 
                        }}
                      >
                        ${remaining.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> */}
                            <div style={{ marginTop: "2rem" }}>
                              {" "}
                              <div
                                className="table-container"
                                style={{ overflowX: "auto" }}
                              >
                                <table
                                  className="styled-table"
                                  style={{
                                    fontSize: "1.1rem",
                                    width: "95%",
                                    borderCollapse: "collapse",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    margin: 0,
                                    padding: 0,
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        background: "#2C3E50",
                                        color: "white",
                                      }}
                                    >
                                      {" "}
                                      <th style={{ padding: "0.6rem" }}>
                                        {t("cause.expenditure.date")}
                                      </th>
                                      <th style={{ padding: "0.6rem" }}>
                                        {t("cause.expenditure.narration")}
                                      </th>
                                      <th style={{ padding: "0.6rem" }}>
                                        {t("cause.expenditure.category")}
                                      </th>
                                      <th style={{ padding: "0.6rem" }}>
                                        {t("cause.expenditure.customer")}
                                      </th>
                                      <th
                                        style={{
                                          padding: "0.6rem",
                                          textAlign: "right",
                                        }}
                                      >
                                        {t("cause.expenditure.amount")}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {CauseSingle.expenditureTransactions.map(
                                      (item, index) => {
                                        const rowStyle =
                                          index % 2 === 0
                                            ? { background: "white" }
                                            : {
                                                background:
                                                  "rgba(240, 247, 255, 0.5)",
                                              };

                                        return (
                                          <tr key={index} style={rowStyle}>
                                            <td
                                              style={{
                                                padding: "0.5rem",
                                                borderBottom: "1px solid #eee",
                                                fontSize: "1rem",
                                                color: "black",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {new Date(
                                                  item.TranDate,
                                                ).toLocaleDateString()}
                                              </span>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem",
                                                fontSize: "1rem",
                                                color: "black",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              {item.Narration}
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem",
                                                fontSize: "1rem",
                                                borderBottom: "1px solid #eee",
                                                color: "black",
                                              }}
                                            >
                                              {item.Category}
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem",
                                                fontSize: "1rem",
                                                color: "black",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              {item.CustomerName}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                              <span
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                <svg
                                                  width="14"
                                                  height="14"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  style={{ marginRight: "4px" }}
                                                >
                                                  <path
                                                    d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                </svg>
                                                {parseFloat(
                                                  item.TranAmt,
                                                ).toFixed(2)}
                                              </span>
                                            </td>
                                          </tr>
                                        );
                                      },
                                    )}
                                    {CauseSingle.expenditureTransactions
                                      .length === 0 && (
                                      <tr>
                                        <td colSpan="5">
                                          <p
                                            style={{
                                              textAlign: "center",
                                              color: "#000",
                                              marginTop: "1rem",
                                              padding: "0.5rem",
                                            }}
                                          >
                                            {t(
                                              "cause.expenditure.noTransactions",
                                            )}
                                          </p>
                                        </td>
                                      </tr>
                                    )}

                                    {CauseSingle.expenditureTransactions
                                      .length > 0 && (
                                      <tr
                                        style={{
                                          backgroundColor: "#f8f9fa",
                                        }}
                                      >
                                        <td
                                          colSpan="4"
                                          style={{
                                            textAlign: "right",
                                            padding: "0.6rem",
                                          }}
                                        >
                                          {t("cause.expenditure.total")}
                                        </td>
                                        <td
                                          style={{
                                            color: "#000",
                                            padding: "0.6rem",
                                            textAlign: "right",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "flex-end",
                                            }}
                                          >
                                            <svg
                                              width="14"
                                              height="14"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              style={{ marginRight: "4px" }}
                                            >
                                              <path
                                                d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                            {CauseSingle.expenditureTransactions
                                              .reduce(
                                                (sum, item) =>
                                                  sum +
                                                  parseFloat(item.TranAmt || 0),
                                                0,
                                              )
                                              .toFixed(2)}
                                          </span>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                )}

              {activeTab === "review" && (
                <div className="tab-pane fade show active">
                  {/*  Reactions Bar */}

                  <div className="mb-4 position-relative">
                    <strong className="me-2">
                      {t("cause.reviews.reactions")}
                    </strong>
                    <div className="d-inline-flex align-items-center gap-2">
                      <button
                        className="btn border rounded-circle p-2"
                        onClick={() =>
                          setShowReactionPicker(!showReactionPicker)
                        }
                        title={t("cause.reviews.reactLabel")}
                      >
                        <span style={{ fontSize: "1.3rem" }}>➕</span>
                      </button>

                      {/* Display selected emoji reactions with counts */}
                      {Object.entries(reactionCounts).map(([key, count]) =>
                        count > 0 ? (
                          <div
                            key={key}
                            className="d-flex align-items-center justify-content-center border rounded-pill px-3 py-1 bg-light shadow-sm"
                          >
                            <span
                              style={{ fontSize: "1.2rem", marginRight: "6px" }}
                            >
                              {reactionEmojiMap[key]}
                            </span>
                            <span
                              className="text-muted"
                              style={{ fontSize: "0.9rem" }}
                            >
                              {count}
                            </span>
                          </div>
                        ) : null,
                      )}
                    </div>

                    {/* Floating emoji picker */}
                    {showReactionPicker && (
                      <div
                        className="position-absolute bg-white shadow-sm p-2 rounded-pill"
                        style={{
                          top: "-60px",
                          left: "0",
                          zIndex: 10,
                          display: "flex",
                          gap: "10px",
                          border: "1px solid #ccc",
                        }}
                      >
                        {Object.entries(reactionEmojiMap).map(
                          ([key, emoji]) => (
                            <button
                              key={key}
                              className="btn btn-light border-0"
                              style={{ fontSize: "1.4rem" }}
                              onClick={() => handleQuickReaction(key)}
                              title={key}
                            >
                              {emoji}
                            </button>
                          ),
                        )}
                      </div>
                    )}
                  </div>

                  {/* 📝 Reviews */}

                  <h4 className="fw-bold mb-4">
                    {t("cause.reviews.forTitle", { title: CauseSingle.title })}
                  </h4>

                  {CauseSingle.reviews && CauseSingle.reviews.length > 0 ? (
                    CauseSingle.reviews
                      .sort((a, b) => new Date(b.date) - new Date(a.date))
                      .map((review, index) => (
                        <div
                          key={index}
                          className="card mb-3 border-0 shadow-sm animate__animated animate__fadeIn"
                        >
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <div className="fw-semibold text-dark">
                                {review.name}
                              </div>
                              <small className="text-muted">
                                {new Date(review.date)}
                              </small>
                            </div>
                            <p className="mb-2">{review.message}</p>
                            {review.reaction && (
                              <div className="d-flex align-items-center mt-2">
                                <span
                                  style={{
                                    fontSize: "1.2rem",
                                    marginRight: "6px",
                                  }}
                                >
                                  {reactionEmojiMap[review.reaction]}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                  ) : (
                    <p>{t("cause.reviews.empty")}</p>
                  )}

                  {/* ✍️ Review Form */}
                  <div className="card mt-4 shadow-sm border-0">
                    <div className="card-body">
                      <h5 className="fw-bold mb-3">
                        {t("cause.reviews.leave")}
                      </h5>
                      <form onSubmit={handleSubmitReview}>
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={t("cause.reviews.namePlaceholder")}
                            value={reviewForm.name}
                            onChange={(e) =>
                              setReviewForm({
                                ...reviewForm,
                                name: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <textarea
                            className="form-control"
                            placeholder={t("cause.reviews.messagePlaceholder")}
                            rows="3"
                            maxLength={250}
                            value={reviewForm.message}
                            onChange={(e) =>
                              setReviewForm({
                                ...reviewForm,
                                message: e.target.value,
                              })
                            }
                            required
                          ></textarea>
                          <small className="text-muted d-block text-end">
                            {reviewForm.message.length}/250
                          </small>
                        </div>
                        <div className="mb-3">
                          <label className="me-2">
                            {t("cause.reviews.reactionLabel")}
                          </label>
                          {Object.entries(reactionEmojiMap).map(
                            ([key, emoji]) => (
                              <button
                                key={key}
                                className="btn btn-light border-0"
                                style={{ fontSize: "1.4rem" }}
                                title={key}
                                onClick={() => {
                                  handleQuickReaction(key);
                                  setReviewForm({
                                    ...reviewForm,
                                    reaction: key,
                                  });
                                }}
                              >
                                {emoji}
                              </button>
                            ),
                          )}
                        </div>

                        <button
                          type="submit"
                          className="btnActions d-block w-100 px-4 py-2 mt-2 text-white fw-bold"
                          disabled={!reviewForm.name || !reviewForm.message}
                        >
                          {t("cause.reviews.submit")}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* popups  */}
      {/* backers pop up */}
      <BackersModal
        show={showBackersModal}
        handleClose={() => setShowBackersModal(false)}
        causeId={CauseSingle.id}
      />

      {/* location map model */}
      <LocationModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        location={CauseSingle.location_district}
        latitude={CauseSingle.latitude}
        longitude={CauseSingle.longitude}
        title={CauseSingle.title}
      />

      {/* share model */}
      {/* <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        shareUrl={window.location.href}
        title={CauseSingle.title}
      /> */}
      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        shareUrl={projectShareUrl}
        projectImage={mainImage} // Use the main image you're already setting
        projectTitle={currentProject?.title}
        projectDescription={currentProject?.description} // Assuming 'description' is a field in your project data
        donateUrl={projectDonateUrl}
      />
      {/* community model pop up */}
      <CommunityModal
        isOpen={communityOpen}
        onClose={() => setCommunityOpen(false)}
        communityData={CauseSingle.Project_committee}
      />
      {/* organization model pop up */}
      <OrganizationModal
        isOpen={showOrgModal}
        onClose={() => setShowOrgModal(false)}
        organization={CauseSingle}
      />

      {/* Settlement detail modal */}
      {settlementModal && settlementModal.settlement ? (
        <div
          onClick={() => setSettlementModal(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0,0,0,0.55)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            padding: "16px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: 16,
              width: "100%",
              maxWidth: 460,
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 12px 50px rgba(0,0,0,0.25)",
              fontFamily: "system-ui, sans-serif",
            }}
          >
            {(() => {
              const stripColon = (s) => (s || "").replace(/[:：]\s*$/, "");
              const original = Number(settlementModal.TranAmt || 0);
              const settled =
                settlementModal.settlement.amount != null
                  ? Number(settlementModal.settlement.amount)
                  : null;
              const fee = settled != null ? original - settled : 0;
              const hasFee = fee > 0.01;
              const displaySettled = settled != null ? settled : original;
              const isFullySettled = !hasFee;
              const receipt = settlementModal.settlement.settlement || {};
              const reference = receipt.TranNo;
              const account = receipt.AccNo;
              const settledAt = settlementModal.settlement.settledAt;

              return (
                <>
                  {/* Header */}
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #00CC99 0%, #00A37A 100%)",
                      padding: "20px 24px",
                      color: "#fff",
                      position: "relative",
                    }}
                  >
                    <button
                      onClick={() => setSettlementModal(null)}
                      aria-label="Close"
                      style={{
                        position: "absolute",
                        top: 14,
                        right: 16,
                        border: "none",
                        background: "rgba(255,255,255,0.2)",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        fontSize: 20,
                        cursor: "pointer",
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      &times;
                    </button>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                      }}
                    >
                      <div
                        style={{
                          background: "rgba(255,255,255,0.22)",
                          width: 46,
                          height: 46,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <i
                          className="fas fa-check-circle"
                          style={{ fontSize: 24 }}
                        ></i>
                      </div>
                      <div style={{ minWidth: 0 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            flexWrap: "wrap",
                          }}
                        >
                          <h5
                            style={{
                              margin: 0,
                              fontSize: 18,
                              fontWeight: 700,
                            }}
                          >
                            {t("cause.settlement.title")}
                          </h5>
                          <span
                            style={{
                              background: "rgba(255,255,255,0.25)",
                              fontSize: 11,
                              fontWeight: 600,
                              padding: "2px 9px",
                              borderRadius: 999,
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 4,
                              textTransform: "uppercase",
                              letterSpacing: "0.4px",
                            }}
                          >
                            <i
                              className="fas fa-shield-alt"
                              style={{ fontSize: 9 }}
                            ></i>
                            {t("cause.settlement.verified")}
                          </span>
                        </div>
                        <p
                          style={{
                            margin: "4px 0 0",
                            fontSize: 13,
                            color: "rgba(255,255,255,0.9)",
                            lineHeight: 1.4,
                          }}
                        >
                          {t("cause.settlement.description")}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Body */}
                  <div style={{ padding: "20px 24px" }}>
                    {/* Transfer flow */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "stretch",
                        gap: 8,
                        marginBottom: 18,
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          background: "#f8f9fa",
                          border: "1px solid #eee",
                          borderRadius: 10,
                          padding: "10px 12px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 11,
                            color: "#888",
                            marginBottom: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 5,
                          }}
                        >
                          <i className="fas fa-credit-card"></i>
                          {t("cause.settlement.donationLabel")}
                        </div>
                        <div
                          style={{
                            fontSize: 16,
                            fontWeight: 700,
                            color: "#2C3E50",
                          }}
                        >
                          ${original.toFixed(2)}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#00CC99",
                          fontSize: 18,
                        }}
                      >
                        <i className="fas fa-arrow-right"></i>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          background: "rgba(0,204,153,0.08)",
                          border: "1px solid rgba(0,204,153,0.35)",
                          borderRadius: 10,
                          padding: "10px 12px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 11,
                            color: "#00A37A",
                            marginBottom: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 5,
                          }}
                        >
                          <i className="fas fa-university"></i>
                          {stripColon(t("cause.settlement.communityAccount"))}
                        </div>
                        <div
                          style={{
                            fontSize: 15,
                            fontWeight: 700,
                            color: "#00A37A",
                            fontFamily: "monospace",
                            wordBreak: "break-all",
                          }}
                        >
                          {account || "—"}
                        </div>
                      </div>
                    </div>

                    {/* Amount breakdown */}
                    <div
                      style={{
                        border: "1px solid #eee",
                        borderRadius: 10,
                        padding: "12px 14px",
                        marginBottom: 18,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: 14,
                          color: "#555",
                          marginBottom: hasFee ? 8 : 0,
                        }}
                      >
                        <span>
                          {stripColon(t("cause.settlement.originalDonation"))}
                        </span>
                        <span style={{ fontWeight: 600, color: "#2C3E50" }}>
                          ${original.toFixed(2)}
                        </span>
                      </div>
                      {hasFee ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: 14,
                            color: "#555",
                          }}
                        >
                          <span>{t("cause.settlement.processingFee")}</span>
                          <span style={{ fontWeight: 600, color: "#dc3545" }}>
                            −${fee.toFixed(2)}
                          </span>
                        </div>
                      ) : null}
                      <div
                        style={{
                          height: 1,
                          background: "#eee",
                          margin: "10px 0",
                        }}
                      ></div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: "#2C3E50",
                          }}
                        >
                          {t("cause.settlement.settledToCommunity")}
                        </span>
                        <span
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: "#00CC99",
                          }}
                        >
                          ${displaySettled.toFixed(2)}
                        </span>
                      </div>
                      {isFullySettled ? (
                        <div
                          style={{
                            marginTop: 8,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 5,
                            background: "rgba(0,204,153,0.1)",
                            color: "#00A37A",
                            fontSize: 12,
                            fontWeight: 600,
                            padding: "3px 10px",
                            borderRadius: 999,
                          }}
                        >
                          <i className="fas fa-check"></i>
                          {t("cause.settlement.fullySettled")}
                        </div>
                      ) : null}
                    </div>

                    {/* Details */}
                    {settledAt || reference ? (
                      <div style={{ marginBottom: 16 }}>
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#888",
                            textTransform: "uppercase",
                            letterSpacing: "0.4px",
                            marginBottom: 8,
                          }}
                        >
                          {t("cause.settlement.detailsTitle")}
                        </div>
                        {settledAt ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              fontSize: 14,
                              padding: "6px 0",
                              borderBottom: reference
                                ? "1px solid #f2f2f2"
                                : "none",
                            }}
                          >
                            <span
                              style={{
                                color: "#666",
                                display: "flex",
                                alignItems: "center",
                                gap: 7,
                              }}
                            >
                              <i
                                className="far fa-calendar-alt"
                                style={{ color: "#aaa" }}
                              ></i>
                              {stripColon(t("cause.settlement.settledOn"))}
                            </span>
                            <span style={{ color: "#2C3E50", fontWeight: 500 }}>
                              {new Date(settledAt).toLocaleDateString(
                                undefined,
                                {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                },
                              )}
                            </span>
                          </div>
                        ) : null}
                        {reference ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              fontSize: 14,
                              padding: "6px 0",
                            }}
                          >
                            <span
                              style={{
                                color: "#666",
                                display: "flex",
                                alignItems: "center",
                                gap: 7,
                              }}
                            >
                              <i
                                className="fas fa-hashtag"
                                style={{ color: "#aaa" }}
                              ></i>
                              {stripColon(t("cause.settlement.reference"))}
                            </span>
                            <span
                              style={{
                                color: "#2C3E50",
                                fontWeight: 500,
                                fontFamily: "monospace",
                                wordBreak: "break-all",
                                textAlign: "right",
                                maxWidth: "60%",
                              }}
                            >
                              {reference}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    ) : null}

                    {/* Transparency note */}
                    {/* <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 8,
                        background: "#f8f9fa",
                        borderRadius: 8,
                        padding: "10px 12px",
                        fontSize: 12,
                        color: "#777",
                        lineHeight: 1.5,
                      }}
                    >
                      <i
                        className="fas fa-lock"
                        style={{ color: "#00CC99", marginTop: 2 }}
                      ></i>
                      <span>{t("cause.settlement.transparencyNote")}</span>
                    </div> */}
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      ) : null}

      {/* Image Lightbox Modal */}
      {lightboxImage && (
        <div
          onClick={() => setLightboxImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999,
            padding: "20px",
          }}
        >
          <button
            onClick={() => setLightboxImage(null)}
            style={{
              position: "absolute",
              top: "16px",
              right: "20px",
              background: "rgba(255,255,255,0.15)",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "#fff",
              fontSize: "20px",
              lineHeight: 1,
            }}
          >
            &times;
          </button>
          <img
            src={lightboxImage.src}
            alt={lightboxImage.title}
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90vw",
              maxHeight: "80vh",
              objectFit: "contain",
              borderRadius: "12px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
            }}
          />
          {lightboxImage.title && (
            <p
              style={{
                color: "rgba(255,255,255,0.85)",
                marginTop: "14px",
                fontSize: "15px",
                fontWeight: "500",
                textAlign: "center",
                maxWidth: "600px",
              }}
            >
              {lightboxImage.title}
            </p>
          )}
        </div>
      )}

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default CauseSinglePage;
